import { application } from "../../../../_runtime/bootstrap";
import { FC, useEffect } from "react";
import { CustomInput, Table } from "taltech-styleguide";

type Props = {
  tableItems: any[];
  columns: {
    header: string;
    accessor: string;
  }[];
  selected?: string[];
  setSelected?: (selected: string[]) => void;
  hasEdit?: boolean;
};

/**
 * Functional Component: PresetsTableSelection
 * 
 * This component renders a table for selecting preset items. It includes checkboxes for selecting items
 * and displays the items based on the provided columns configuration.
 * 
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.tableItems - An array of items to be displayed in the table.
 * @param {Array} props.columns - The columns configuration for the table.
 * @param {Array<string>} props.selected - An array of selected item IDs.
 * @param {Function} props.setSelected - Function to set the selected items.
 * @param {boolean} [props.hasEdit=false] - Flag indicating whether the table has edit functionality.
 * 
 * Returns:
 * @returns {JSX.Element} A JSX element containing the table for selecting preset items.
 */
export const PresetsTableSelection: FC<Props> = ({
  tableItems,
  columns,
  selected,
  setSelected,
  hasEdit = false,
}) => {
  const onSelectioChange = (id: string) => {
    if (selected !== undefined && setSelected !== undefined) {
      if (selected.includes(id)) {
        setSelected(selected.filter((s) => s !== id));
      } else {
        setSelected([...selected, id]);
      }
    }
  };

  return (
    <Table className="table-hover text-sm">
      <thead>
        {columns.map((column) => (
          <th key={column.accessor}>
            <div className="table__header">{column.header}</div>
          </th>
        ))}
      </thead>
      <tbody>
        {tableItems.map((spaceFunction: any, index: number) => (
          <tr key={spaceFunction.id + index}>
            <td>
              {hasEdit && (
                <CustomInput
                  type="checkbox"
                  checked={selected!.includes(spaceFunction.id)}
                  onChange={() => onSelectioChange(spaceFunction.id)}
                />
              )}
            </td>
            {columns.slice(1).map((column) => (
              <td key={column.accessor}>{spaceFunction[column.accessor]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
